import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/Layout'

// START - 解决 vue-router 连续点击导航报 NavigationDuplicated: Avoided redundant navigation to current location 的问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
// END

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Layout,
        redirect: '/home',
        meta: {breadcrumbTitle: '首页', breadcrumbPath: '/home'},
        children: [
            {
                path: '/home',
                name: 'home',
                component: () => import(/* webpackChunkName: "index" */ '../views/home/home.vue'),
                meta: {breadcrumbTitle: '首页', breadcrumbPath: '/home'},
            },
            {
                path: '/addForm',
                name: 'addForm',
                component: () => import('../views/home/addForm.vue'),
                meta: {breadcrumbTitle: '评估表单', breadcrumbPath: '/addForm'},
            },
            {
                path: '/detail',
                name: 'detail',
                component: () => import('../views/home/detail.vue'),
                meta: {breadcrumbTitle: '估值结果', breadcrumbPath: '/detail'},
            },
            {
                path: '/user',
                name: 'user',
                component: () => import('../views/user/user.vue'),
                meta: {breadcrumbTitle: '个人资料', breadcrumbPath: '/user'}
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/login.vue')
    }
]

const router = new VueRouter({
    routes
})

export default router
